import React, { useState, useEffect, useCallback } from 'react';
import { FileText, FilePen, FileStack, CircleDollarSign, Ban, AlertTriangle, List } from 'lucide-react';
import Tabs from '../../ui/Tabs.jsx';
import InvoicesCurrentModern from '../../ModernTable/InvoicesCurrentModern';
import InvoicesDraftsModern from '../../ModernTable/InvoicesDraftsModern';
import InvoicesTemplatesModern from '../../ModernTable/InvoicesTemplatesModern';
import InvoicesPayedModern from '../../ModernTable/InvoicesPayedModern';
import InvoicesCanceledModern from '../../ModernTable/InvoicesCanceledModern';
import InvoicesRemindersModern from '../../ModernTable/InvoicesRemindersModern';
import InvoicesAllModern from '../../ModernTable/InvoicesAllModern';

const InvoicesTabs = () => {
    const [invoicesCounts, setInvoicesCounts] = useState({
        allInvoices: 0,
        currentInvoices: 0,
        drafts: 0,
        templates: 0,
        payedInvoices: 0,
        canceledInvoices: 0,
        reminders: 0
    });
    const [activeTab, setActiveTab] = useState('currentInvoices');

    const fetchInvoicesCounts = useCallback(async () => {
        try {
            const response = await fetch('index.php/invoices/getNumberOfInvoices');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setInvoicesCounts({
                allInvoices: data.allInvoices,
                currentInvoices: data.currentInvoices,
                drafts: data.drafts,
                templates: data.templates,
                payedInvoices: data.payedInvoices,
                canceledInvoices: data.canceledInvoices,
                reminders: data.reminders
            });
        } catch (error) {
            console.error('Error fetching invoices counts:', error);
        }
    }, []);

    useEffect(() => {
        fetchInvoicesCounts();
    }, [fetchInvoicesCounts]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    const tabsData = [
        {
            id: 'currentInvoices',
            name: 'Aktuell',
            icon: FileText,
            count: invoicesCounts.currentInvoices,
            content: <InvoicesCurrentModern updateCounts={fetchInvoicesCounts} />
        },
        {
            id: 'drafts',
            name: 'Entwürfe',
            icon: FilePen,
            count: invoicesCounts.drafts,
            content: <InvoicesDraftsModern updateCounts={fetchInvoicesCounts} />
        },
        {
            id: 'templates',
            name: 'Vorlagen',
            icon: FileStack,
            count: invoicesCounts.templates,
            content: <InvoicesTemplatesModern updateCounts={fetchInvoicesCounts} />
        },
        {
            id: 'payedInvoices',
            name: 'Bezahlt',
            icon: CircleDollarSign,
            count: invoicesCounts.payedInvoices,
            content: <InvoicesPayedModern updateCounts={fetchInvoicesCounts} />
        },
        {
            id: 'canceledInvoices',
            name: 'Storniert',
            icon: Ban,
            count: invoicesCounts.canceledInvoices,
            content: <InvoicesCanceledModern updateCounts={fetchInvoicesCounts} />
        },
        {
            id: 'reminders',
            name: 'Mahnungen',
            icon: AlertTriangle,
            count: invoicesCounts.reminders,
            content: <InvoicesRemindersModern updateCounts={fetchInvoicesCounts} />
        },
        {
            id: 'allInvoices',
            name: 'Alle Rechnungen',
            icon: List,
            count: invoicesCounts.allInvoices,
            content: <InvoicesAllModern updateCounts={fetchInvoicesCounts} />
        }
    ];

    return (
        <div>
            <Tabs tabs={tabsData} onTabChange={handleTabChange} />
        </div>
    );
};

export default InvoicesTabs;
